<template>
  <div class="page">
        <!-- 搜索 -->
  <el-form v-if="isSearch" :model="queryForm" ref="form" label-width="80px" :inline="true" size="small" class="query-form" @submit.native.prevent>
              <el-form-item label="分类名称">
                  <el-input style="width: 200px" v-model="queryForm.categoryName"></el-input>
              </el-form-item>
              <el-form-item label="存储区域">
<!--                  <el-input  v-model="queryForm.storageId"></el-input>-->
                  <el-select
                      clearable
                      style="width: 200px"
                      v-model="queryForm.storageId"
                      placeholder="请选择"
                      size="small"
                  >
                      <el-option
                          v-for="item in washStorageAreaList"
                          :label="item.areaName"
                          :value="item.id"
                      > </el-option>
                  </el-select>
              </el-form-item>
              <el-form-item>
                  <el-button size="small" type="primary" icon="el-icon-search" @click="getWashProductCategoryList">查询</el-button>
                  <el-button size="small" icon="el-icon-refresh" @click="resetDialog">重置</el-button>
              </el-form-item>
  </el-form>
  <div class="page-content">
    <div class="page-tool-bar">
      <div class="el-btn-group">
        <el-button
          type="primary"
          size="small"
          icon="el-icon-plus"
          @click="addWashProductCategory"
        >新建</el-button>
        <el-button
          type="warning"
          plain
          size="small"
          icon="el-icon-edit"
          :disabled="multipleSelection.length != 1"
          @click="editWashProductCategory(null)"
        >修改</el-button>
        <el-button
          type="danger"
          plain
          size="small"
          icon="el-icon-delete"
          :disabled="multipleSelection.length <= 0"
          @click="deleteWashProductCategory(null)"
        >删除</el-button>
      </div>

      <div class="icon-group">
            <el-upload v-if="this.isImportDate"
              class="upload-demo"
              action="#"
                            :http-request="upload"
              :show-file-list="true">
              <el-button size="small" type="primary">点击上传</el-button>
              <div slot="tip" class="el-upload__tip">只允许导入“xls”或“xlsx”格式文件！</div>
            </el-upload>
        <span
          title="搜索"
          class="icon-box"
          @click="search"
        >
          <Icon color="#606266">
            <Search />
          </Icon>
        </span>
        <span
          class="icon-box"
          @click="refreshWashProductCategoryList"
        >
          <Icon color="#606266">
            <Refresh />
          </Icon>
        </span>
      </div>
    </div>
          <!-- 列表数据 -->
    <el-table
      :data="washProductCategoryList"
      row-key="id"
      border
      height="100%"
      :header-row-style="{height: '10px'}"
      :header-cell-style="{padding: '10px'}"
      :row-style="{height: '9px'}"
      :cell-style="{padding: '9px'}"
      @selection-change="handleSelectionChange"
      size="small"
    >
      <el-table-column
        align="center"
        type="selection"
        width="60"
      > </el-table-column>
      <el-table-column
        :show-overflow-tooltip="true"
        align="center"
        prop="categoryName"
        label="分类名称"
      > </el-table-column>
      <el-table-column
        :show-overflow-tooltip="true"
        align="center"
        prop="storageId"
        label="存储区域"
      >
          <template slot-scope="scope">
              {{scope.row.storage ? scope.row.storage.areaName : ''}}
          </template>
      </el-table-column>
      <el-table-column
        :show-overflow-tooltip="true"
        align="center"
        prop="sort"
        label="排序"
      > </el-table-column>
      <el-table-column
        :show-overflow-tooltip="true"
        align="center"
        prop="createTime"
        label="创建时间"
      > </el-table-column>
      <el-table-column
        fixed="right"
        align="center"
        label="操作"
        width="300"
      >
        <template slot-scope="scop">
          <div class="operation">
            <div @click="checkWashProductCategory(scop.row.id)">
              <Icon size="16">
                <Eye24Regular />
              </Icon>
              <span class="operation-label">查看</span>
            </div>
            <div @click="editWashProductCategory(scop.row.id)">
              <Icon size="16">
                <Edit24Regular />
              </Icon>
              <span class="operation-label">修改</span>
            </div>
            <div @click="deleteWashProductCategory(scop.row.id)">
              <Icon size="16" style="color: red">
                <Delete24Regular />
              </Icon>
              <span class="operation-label" style="color: red">删除</span>
            </div>
          </div>
        </template>
      </el-table-column>
    </el-table>
    <div class="pagination-box">
      <el-pagination
        @size-change="sizeChange"
        @current-change="currentChange"
        :current-page.sync="currentPage"
        :page-sizes="[10, 20, 50, 100]"
        :page-size="pageSize"
        layout="total, sizes, prev, pager, next, jumper"
        :total="totalNum"
        background
        :pager-count="7"
      >
      </el-pagination>
    </div>
    <!-- 新增/查看/修改信息 -->
    <el-dialog
      :title="washProductCategoryStates[washProductCategoryState]"
      :visible.sync="showDialog"
      width="60%"
      @close="closeDialog"
    >
      <div>
        <el-form
          :model="washProductCategory"
          ref="washProductCategoryForm"
          :rules="rules"
          label-width="120px"
          :inline="true"
          size="small"
        >
          <el-form-item
            label="分类名称"
            prop="categoryName"
          >
            <el-input
              size="small"
              style="width: 200px"
              v-model="washProductCategory.categoryName"
              :disabled="washProductCategoryState == 'check'"
            ></el-input>
          </el-form-item>
          <el-form-item
            label="存储区域"
            prop="storageId"
          >
<!--            <el-input-->
<!--              size="small"-->
<!--              v-model="washProductCategory.storageId"-->
<!--              :disabled="washProductCategoryState == 'check'"-->
<!--            ></el-input>-->
              <el-select
                  clearable
                  style="width: 200px"
                  v-model="washProductCategory.storageId"
                  placeholder="请选择"
                  :disabled="washProductCategoryState == 'check'"
                  size="small"
              >
                  <el-option
                      v-for="item in washStorageAreaList"
                      :label="item.areaName"
                      :value="item.id"
                  > </el-option>
              </el-select>
          </el-form-item>
          <el-form-item
            label="排序"
            prop="sort"
          >
            <el-input
              size="small"
              style="width: 200px"
              v-model="washProductCategory.sort"
              :disabled="washProductCategoryState == 'check'"
            ></el-input>
          </el-form-item>
        </el-form>
      </div>

      <div
        slot="footer"
        class="flex justify-end"
      >
        <el-button @click="closeDialog">关闭</el-button>
        <el-button
          type="primary"
          @click="submitForm"
          v-if="washProductCategoryState != 'check'"
        >确定</el-button>
      </div>
    </el-dialog>
  </div>
  </div>
</template>

<script>
import { ArrowDownload24Regular, ArrowExportUp24Regular } from '@v2icons/fluent';
import { GridDots, Refresh, Printer, ArrowUp, ArrowDown, Search } from '@v2icons/tabler';
import { Edit24Regular, Delete24Regular, Eye24Regular } from '@v2icons/fluent';
import { exprotExcel, importTemplate, importDate, get, post, put, deleteFun } from '@/utils/request.js';

export default {
    components: {
        Edit24Regular,
        Delete24Regular,
        Eye24Regular,
        GridDots,
        Refresh,
        Printer,
        ArrowUp,
        ArrowDown,
        ArrowDownload24Regular,
        ArrowExportUp24Regular,
        Search
    },
        watch: {
            checkState(val) {
                if (val == 'check') {
                    this.resetWashProductCategoryList();
                    this.getWashProductCategoryList(this.queryForm);
                    this.$emit('resetCheckState');
                } else if (val == 'reset') {
                    this.resetWashProductCategoryList();
                    this.getWashProductCategoryList();
                    this.$emit('resetCheckState');
                }
            }
        },
    data() {
            return {
                queryForm:{
                     categoryName: '', //分类名称
                     storageId: '', //存储区域
                     sort: '', //排序
                },
                loading: false,
                showDialog: false,
                isImportDate: false,
                isSearch: false,
                pageSize: 10,
                currentPage: 1,
                totalNum: 0,
                currentUserId: '',
                washProductCategoryState: 'add',
                washProductCategoryStates: {
                    add: '新建物件分类',
                    check: '查看物件分类',
                    edit: '修改物件分类'
                },

                multipleSelection: [],
                washProductCategoryList: [],
                washProductCategory: {
                    id: '', //ID
                    categoryName: '', //分类名称
                    storageId: '', //存储区域
                    sort: '', //排序
                    createTime: '', //创建时间
                },
                btnLoading: false,

                rules: {
                    id: [{ required: true, message: 'ID不能为空', trigger: 'blur' }],
                    categoryName: [{ required: true, message: '分类名称不能为空', trigger: 'blur' }],
                    storageId: [{ required: true, message: '存储区域不能为空', trigger: 'blur' }],
                    sort: [{ required: true, message: '排序不能为空', trigger: 'blur' }],
                },
                washStorageAreaList: [],
            };
        },
        created() {
            this.getWashProductCategoryList();
            this.getWashStorageArea()
        },
        methods: {
            search(){
                this.isSearch = !this.isSearch;
            },
            // 获取存放区域
            getWashStorageArea() {
                get('/wash/storagearea/findAll').then((res)=>{
                    if(res.success){
                        this.washStorageAreaList = res.list;
                    }else{
                        this.$message.error(res.msg);
                    }
                })
            },
            resetWashProductCategoryList() {
                this.pageSize = 10;
                this.currentPage = 1;
                this.washProductCategoryList = [];
            },
            resetDialog() {
                this.washProductCategoryState = 'add';
                this.showDialog = false;
                this.queryForm = {
                      categoryName: '', //分类名称
                      storageId: '', //存储区域
                      sort: '', //排序
                };
                this.getWashProductCategoryList();
            },
            closeDialog() {
                this.showDialog = false
                this.washProductCategory = {
                      id: '', //ID
                      categoryName: '', //分类名称
                      storageId: '', //存储区域
                      sort: '', //排序
                      createTime: '', //创建时间
                };
            },
            submitForm() {
                if (this.washProductCategoryState == 'add') {
                    this.$refs.washProductCategoryForm.validate((valid) => {
                        if (valid) {
                            console.log('submit');
                            post(`/wash/productcategory/add`,{ ...this.washProductCategory }).then((res) => {
                                if (res.success) {
                                    this.$message({
                                        message: res.msg,
                                        type: 'success',
                                        duration: 2000,
                                    });
                                    this.resetWashProductCategoryList();
                                    this.resetDialog();
                                } else {
                                    this.$message({
                                        message: res.msg,
                                        type: 'error',
                                        duration: 2000
                                    });
                                }
                            });
                        }
                    });
                } else if (this.washProductCategoryState == 'edit') {
                    this.$refs.washProductCategoryForm.validate((valid) => {
                        if (valid) {
                            console.log('submit');
                            delete this.washProductCategory.storage
                            post(`/wash/productcategory/edit`,{ ...this.washProductCategory }).then((res) => {
                                if (res.success) {
                                    this.$message({
                                        message: res.msg,
                                        type: 'success',
                                        duration: 2000
                                    });
                                    this.resetWashProductCategoryList();
                                    this.resetDialog();
                                } else {
                                    this.$message({
                                        message: res.msg,
                                        type: 'error',
                                        duration: 2000
                                    });
                                }
                            });
                        }
                    });
                }
            },
            addWashProductCategory() {
                this.showDialog = true;
                this.washProductCategoryState = 'add';
            },
            checkWashProductCategory(washProductCategoryId) {
                console.log(washProductCategoryId);
                this.currentWashProductCategoryId = washProductCategoryId;

                this.getWashProductCategoryById();
                this.showDialog = true;
                this.washProductCategoryState = 'check';
            },
            editWashProductCategory(washProductCategoryId) {
                console.log('washProductCategory', washProductCategoryId);
                if (washProductCategoryId) {
                    this.currentWashProductCategoryId = washProductCategoryId;
                    this.getWashProductCategoryById();
                } else {
                    this.washProductCategory = { ...this.washProductCategory, ...this.multipleSelection[0] };
                }

                this.showDialog = true;
                this.washProductCategoryState = 'edit';
            },
            deleteWashProductCategory(washProductCategoryId) {
                let ids = '';
                if (washProductCategoryId) {
                    ids = washProductCategoryId;
                } else {
                    ids = this.multipleSelection.map((washProductCategory) => washProductCategory.id).join(',');
                }
                console.log({ ids });
                this.$confirm('确定删除所选项吗？', '提示', {
                    type: 'warning'
                })
                    .then(() => {
                        deleteFun(`/wash/productcategory/delete`,{ ids }).then((res) => {
                            if (res.success) {
                                this.$message({
                                    message: res.msg,
                                    type: 'success',
                                    duration: 2000
                                });
                                this.resetWashProductCategoryList();
                                this.getWashProductCategoryList();
                            } else {
                                this.$message({
                                    message: res.msg,
                                    type: 'error',
                                    duration: 2000
                                });
                            }
                        });
                    })
                    .catch(() => {});
            },
            refreshWashProductCategoryList() {
                this.resetWashProductCategoryList();
                this.getWashProductCategoryList();
            },
            getWashProductCategoryList(query = {}) {
                this.loading = true;
                get(`/wash/productcategory/findList`,{  ...this.queryForm, pageNum: this.currentPage, pageSize: this.pageSize }).then((res) => {
                    this.loading = false;
                    if (res.success) {
                        this.washProductCategoryList = res.page.list;
                        this.totalNum = res.page.total;
                    } else {
                        this.$message({
                            message: res.msg,
                            type: 'error',
                            duration: 2000
                        });
                    }
                });
            },
            getWashProductCategoryById() {
                get(`/wash/productcategory/get`,{ id: this.currentWashProductCategoryId }).then((res) =>{
                    if(res.success){
                      this.washProductCategory = { ...this.washProductCategory, ...res.washProductCategory };
                    } else {
                        this.$message({
                            message: res.msg,
                            type: 'error',
                            duration: 2000
                        });
                    }
                });
            },
            /**
             * 导出信息
             */
            exportWashProductCategoryList() {
                //this.btnLoading = true;
                exprotExcel(`/wash/productcategory/export`, {...this.queryForm});
            },
            /**
             * 导出模板
             */
            importTemplate() {
                this.btnLoading = true;
                importTemplate(`/wash/productcategory/importTemplate`, this.btnLoading);
            },
            /**
             * 导入数据
             */
            isImport() {
                this.isImportDate = !this.isImportDate;
            },
            upload(params){
              const file = params.file;
              const formData = new FormData();
              formData.append('file', file);
              console.log({ formData });
              importDate(`/wash/productcategory/importData`,formData);
              this.refreshWashProductCategoryList();
            },
            handleSelectionChange(value) {
                console.log(value);
                this.multipleSelection = value;
            },
            currentChange(page) {
                this.currentPage = page;
                this.getWashProductCategoryList();
            },
            sizeChange(size) {
                this.pageSize = size;
                this.getWashProductCategoryList();
            }
        }

};
</script>

<style lang="scss" scoped>
::v-deep .el-dialog__header {
    border-bottom: 1px solid #eee;
}
.operation {
    display: flex;
    align-items: center;
    justify-content: center;
    color: #409eff;
    font-size: 12px;

    & > div {
        display: flex;
        align-items: center;
        padding: 0 5px;
        cursor: pointer;
    }

    .operation-label {
        margin-left: 3px;
    }
}
</style>